import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { auth as fauth } from 'firebaseui';
import { EmailAuthProvider } from 'firebase/auth';
import { AuthService } from 'src/app/services/auth.service';
import { FireService } from 'src/app/services/fire.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    public loading = true;
    constructor(
        private fire: FireService,
        private auth: AuthService,
        private router: Router
    ) {}
    private ui = new fauth.AuthUI(this.auth.auth);

    async ngOnInit(): Promise<void> {
        const state = await this.auth.getUser();
        if (state != null) {
            this.router.navigate(['']);
        }

        // this.loading = false;

        this.ui.start('#firebaseui-auth-container', {
            callbacks: {
                signInSuccessWithAuthResult: () => {
                    this.auth.getUser().then(() => {
                        this.router.navigate(['']);
                    });
                    return false;
                },
            },

            credentialHelper: fauth.CredentialHelper.NONE,
            signInFlow: 'popup',
            popupMode: true,
            signInOptions: [
                // {
                //     provider: EmailAuthProvider.PROVIDER_ID,
                //     requireDisplayName: false,
                //     disableSignUp:{status: true} ,
                // },
                {
                    provider: 'microsoft.com',
                    customParameters: {
                        tenant: '4767f847-2f46-47ce-b25f-fa9af421268a',
                        prompt: 'select_account',
                    },
                    // requireDisplayName: true,
                },
            ],
        });
    }

    // public async signIn() {
    //     this.loading = true;
    //     await this.auth.singIn().then( _ => {
    //         this.router.navigate(['']);
    //         this.loading = false;
    //     })
    //     .catch(e => {
    //         this.loading = false;
    //         console.error(e)
    //     });
    // }
}
